import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
} from '@oneaudi/unified-web-common';

const removePxFromValue = (value: string | number): number =>
  typeof value === 'number' ? value : parseFloat(value);
export const xsWidth = removePxFromValue(SYS_BREAKPOINT_XS);
export const mdWidth = removePxFromValue(SYS_BREAKPOINT_MD);
export const lgWidth = removePxFromValue(SYS_BREAKPOINT_LG);
export const xlWidth = removePxFromValue(SYS_BREAKPOINT_XL);
export const xxlWidth = removePxFromValue(SYS_BREAKPOINT_2_XL);
